const social = {
  twitterX: "https://twitter.com/lyssp_writes",
  instagram: "https://www.instagram.com/alyssa__writes/",
  wattpad: "https://www.wattpad.com/user/lyssspotter",
};

export default social;
